import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C7Position, useC7PositionColumns } from "./columns";
import { type FilterC7PositionsSchema, FilterC7Positions } from "./filter";

export const C7PositionsTable = () => {
  const columns = useC7PositionColumns();
  return (
    <Table<C7Position, FilterC7PositionsSchema>
      label="Positions"
      client={Clients.C7}
      table_name={Tables.C7_POSITIONS}
      columns={columns}
      filter={<FilterC7Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.C7}/${Tables.C7_POSITIONS}/new`,
        },
      ]}
    />
  );
};
